<template>
    <div class="n2-container">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.role.back') }}
                    </span>
                </div>
            </a>
        </div>
        <div class="n2-page-title">
            <h3 v-if="id==='new'">{{$t('pages.admin.content.new')}}</h3>
            <h3 v-else>{{$t('pages.admin.content.content')}}</h3>
        </div>
        <div class="n2-container">
            <form method="post" v-on:submit.prevent="onSubmit">
                <div class="n2-row-padding">
                    <div class="col-md-12">
                        <div class="n2-panel-default">
                            <form-input type="text" v-model="entity.name" v-bind:label="$t('pages.admin.content.name')" v-bind:errors="model_errors.name"></form-input>
                            <div class="n2-row-padding">
                                <div class="col-md-6">
                                    <div class="n2-form-group">
                                        <label class="n2-form-label">{{$t('pages.admin.content.start_at')}}</label>
                                        <input class="n2-input-default" type="date" v-model="entity.start_at" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="n2-form-group">
                                        <label class="n2-form-label">{{$t('pages.admin.content.end_at')}}</label>
                                        <input class="n2-input-default" type="date" v-model="entity.end_at" />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <h5>{{$t('pages.admin.content.content')}}</h5>

                        <div v-for="res in entity.content_resources" v-bind:key="res" style="">
                            <div class="n2-panel-default" style="">
                                <div style="padding: 16px 0;">
                                    <div style="text-align:center;font-weight:bold; font-size:15px;">{{res.language}}</div>
                                    <div>
                                        <textarea style="width:100%; min-height:500px;" v-model="res.content" class="n2-input-default" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <validation-summary v-bind:errors="model_errors"></validation-summary>

                        <div class="n2-form-group">
                            <div v-if="id==='new'" class="n2-text-right">
                                <input type="submit" v-bind:value="$t('pages.admin.content.create')" class="n2-button-1" />
                            </div>
                            <div v-else class="n2-display-flex n2-justify-content-space-between">
                                <span class="n2-button-1 n2-button-delete" onclick="document.getElementById('n1-delete-modal').style.display='block'">{{$t('pages.admin.content.delete')}}</span>
                                <input type="submit" v-bind:value="$t('pages.admin.content.save')" class="n2-button-1" />
                            </div>
                        </div>
                        <!--delete---------------------------------->
                        <div id="n1-delete-modal" class="w3-modal">
                            <div class="w3-modal-content w3-card-4" style="max-width:600px">
                                <div class="w3-center">
                                    <br>
                                    <span v-on:click="closeModal" class="w3-button w3-xlarge w3-hover-red w3-display-topright" title="Close Modal">&times;</span>
                                    <label class="n2-form-label">{{$t('pages.admin.content.confirm_delete')}}</label>
                                </div>
                                <div class="w3-container w3-padding-16">
                                    <button type="button" class="n2-button-1 n2-button-delete n2-right" v-on:click="deleteEntity()">{{$t('pages.admin.content.delete')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>


<script>
    import { mapGetters } from 'vuex';
    import {
        ContentService, LocaleService

    } from '../services';
    import FormInput from "../components/shared/form-input.vue";
    import ValidationSummary from "../components/shared/validation-summary.vue";


    export default {
        components: {
            FormInput, ValidationSummary
        },
        props: {
        },
        data: function () {
            return {
                model_errors: {},
                id: '',
                languages: [],
                entity: {
                    name: '',
                    start_at: '',
                    end_at: '',
                    content_resources: []
                },


                lines: [],
                routes: [],
                routesets: [],
                journeys: [],
                journey_patterns: [],
                journey_pattern_sequences: [],


                line: null,
                route: null,
                journey: null,

                journey_pattern: null,
                journey_pattern_sequence: null,

            }
        },
        computed: {
            ...mapGetters('app_settings', [
                'company_id'
            ]),
            ...mapGetters('globalization', [
                'locale',
                'language'
            ]),

        },
        watch: {

        },
        created: function () {
            this.contentService = new ContentService();
            this.localeService = new LocaleService();

        },
        mounted: async function () {
            const { id } = this.$route.params;
            this.id = id;
            await this.load(this.$route.query);
            if (id !== 'new') {
                await this.loadEntity(id);
            }
        },
        beforeRouteUpdate: async function (to, from, next) {
            if (to.query.company_id !== from.query.company_id || to.query.routeset_id !== from.query.routeset_id) {
                next({
                    path: this.$route.path.substring(0, this.$route.path.lastIndexOf('/')), query: to.query
                });
            }
            else {
                next();
            }
        },
        methods: {
            setRequired: function (content, property, list, idContent, idList) {
                content[property] = content[property].map(req => {
                    var result = list.find(element => element[idList] == req[idContent]);
                    if (result) {
                        return result;
                    }
                    else {
                        return {};
                    }
                });
            },
            loadEntity: async function (id) {
                let result = await this.contentService.find(id);
                let content = result;
                if (content.start_at) { content.start_at = content.start_at.substr(0, 10); }
                if (content.end_at) { content.end_at = content.end_at.substr(0, 10); }
                content.content_resources = this.languages.map(lang => {
                    return {
                        locale: lang.locale,
                        language: lang.language,
                        content_id: content.content_resources.find(element => element.locale == lang.locale)?.content_id,
                        content: content.content_resources.find(element => element.locale == lang.locale)?.content,

                    }
                });
                this.entity = content;





            },
            load: async function () {
                const [
                    languageResult
                ] = await Promise.all([
                    this.localeService.search(),
                ]);
                this.languages = languageResult.data;
                this.entity.content_resources = this.languages.map(lang => { return { locale: lang.locale, language: lang.language } });

            },



            closeModal: function () {
                var x = document.getElementsByClassName("w3-modal");
                var i;
                for (i = 0; i < x.length; i++) {
                    x[i].style.display = "none";
                }
            },





            checkForm: function () {
                this.model_errors = {};

                if (!this.entity.name) {
                    this.model_errors['name'] = [this.$t('pages.admin.content.error_name_required')];
                }

                if (Object.keys(this.model_errors).length > 0) {
                    return false;
                }
                else {
                    return true;
                }
            },
            onSubmit: async function () {
                if (!this.checkForm()) {
                    return false;
                }
                if (!this.entity.start_at) {
                    this.entity.start_at = null
                }
                if (!this.entity.end_at) {
                    this.entity.end_at = null
                }
                try {
                    if (this.id === 'new') {
                        await this.contentService.create(this.entity);
                    }
                    else {
                        await this.contentService.update(this.entity.id, this.entity);
                    }
                    var parentPath = this.$route.path.substring(0,
                        this.$route.path.endsWith('/') ?
                            this.$route.path.substr(0, this.$route.path.length - 2).lastIndexOf('/')
                            : this.$route.path.lastIndexOf('/'));
                    this.$router.push({
                        path: parentPath,
                        query: this.$route.query
                    }).catch(() => {
                        //throw new Error(`Problem router push: ${err}.`);
                    });
                }
                catch (err) {
                    if (err.response) {
                        this.model_errors = err.response.data;
                    }
                }
            },
            deleteEntity: async function () {
                try {
                    await this.contentService.delete(this.id);
                    var parentPath = this.$route.path.substring(0,
                        this.$route.path.endsWith('/') ?
                            this.$route.path.substr(0, this.$route.path.length - 2).lastIndexOf('/')
                            : this.$route.path.lastIndexOf('/'));
                    this.$router.push({
                        path: parentPath,
                        query: this.$route.query
                    }).catch(() => {
                        //throw new Error(`Problem router push: ${err}.`);
                    });
                }
                catch (err) {
                    if (err.response) {
                        this.model_errors = err.response.data;
                    }
                }
            },
        },

    }
</script>